import React from "react";
import { Plus, X } from "lucide-react";
import { Fld, Inp } from "@/components/portal/crm/kit";

const TEXT = [
  ["summary", "Summary — what a credit manager reads first", 3],
  ["use_of_funds", "Use of funds", 2],
  ["business", "The business", 4],
  ["numbers_comment", "Reading the numbers", 2],
  ["security", "Security & guarantees", 2],
  ["ready_for_terms", "Ready for terms — what's in, what's outstanding", 2],
];

/** Connie's draft, every line editable before it reaches a desk. */
export function PitchFields({ form, set, testId = "hub-pitch" }) {
  const strengths = form.strengths || [];
  const risks = form.risks || [];
  const setAt = (key, i, v) => set(key, (form[key] || []).map((x, j) => (j === i ? v : x)));
  return (
    <div className="dp-ed">
      <Fld label="Headline">
        <Inp value={form.headline || ""} maxLength={200} onChange={(e) => set("headline", e.target.value)} data-testid={`${testId}-headline`} />
      </Fld>
      {TEXT.slice(0, 3).map(([k, label, rows]) => (
        <Fld key={k} label={label}>
          <textarea className="inp" rows={rows} maxLength={1800} value={form[k] || ""} onChange={(e) => set(k, e.target.value)}
                    data-testid={`${testId}-${k}`} />
        </Fld>
      ))}
      <Fld label="Why it works">
        <div className="dp-rows">
          {strengths.map((s, i) => (
            <div key={i} className="dp-row">
              <Inp value={s} maxLength={300} onChange={(e) => setAt("strengths", i, e.target.value)} data-testid={`${testId}-strength-${i}`} />
              <button type="button" className="dp-x" onClick={() => set("strengths", strengths.filter((_, j) => j !== i))}
                      aria-label="Remove" data-testid={`${testId}-strength-${i}-remove`}><X className="size-4" /></button>
            </div>
          ))}
          {strengths.length < 8 && (
            <button type="button" className="dp-add" onClick={() => set("strengths", [...strengths, ""])} data-testid={`${testId}-strength-add`}>
              <Plus className="inline size-3.5" /> Add a reason
            </button>
          )}
        </div>
      </Fld>
      <Fld label="What to know — and why it's manageable">
        <div className="dp-rows">
          {risks.map((r, i) => (
            <div key={i} className="dp-pair">
              <textarea className="inp" rows={2} maxLength={300} value={r.risk} placeholder="What they'll spot"
                        onChange={(e) => setAt("risks", i, { ...r, risk: e.target.value })} data-testid={`${testId}-risk-${i}`} />
              <textarea className="inp" rows={2} maxLength={300} value={r.mitigant} placeholder="Why it's manageable"
                        onChange={(e) => setAt("risks", i, { ...r, mitigant: e.target.value })} data-testid={`${testId}-mitigant-${i}`} />
              <button type="button" className="dp-x" onClick={() => set("risks", risks.filter((_, j) => j !== i))}
                      aria-label="Remove" data-testid={`${testId}-risk-${i}-remove`}><X className="size-4" /></button>
            </div>
          ))}
          {risks.length < 6 && (
            <button type="button" className="dp-add" onClick={() => set("risks", [...risks, { risk: "", mitigant: "" }])}
                    data-testid={`${testId}-risk-add`}><Plus className="inline size-3.5" /> Add a point</button>
          )}
        </div>
      </Fld>
      {TEXT.slice(3).map(([k, label, rows]) => (
        <Fld key={k} label={label}>
          <textarea className="inp" rows={rows} maxLength={800} value={form[k] || ""} onChange={(e) => set(k, e.target.value)}
                    data-testid={`${testId}-${k}`} />
        </Fld>
      ))}
    </div>
  );
}

/** Which of the case's documents go in the pack — PDFs and photos go inside it, anything else alongside. */
export function PitchDocs({ available, chosen, onChange, testId = "hub-pitch-docs" }) {
  if (!available.length) return <p className="dp-fine" style={{ margin: 0 }}>No documents on the case yet — the pack will carry the pitch and the company check.</p>;
  const flip = (id) => onChange(chosen.includes(id) ? chosen.filter((x) => x !== id) : [...chosen, id]);
  return (
    <div className="dp-docs" data-testid={testId}>
      {available.map((f) => (
        <label key={f.id} className="dp-doc">
          <input type="checkbox" checked={chosen.includes(f.id)} onChange={() => flip(f.id)} data-testid={`${testId}-${f.id}`} />
          <span style={{ minWidth: 0 }}>
            <b>{f.label}</b>
            <small>{f.filename} · {f.mergeable ? "goes inside the PDF" : "sent alongside the PDF"}</small>
          </span>
        </label>
      ))}
    </div>
  );
}
